import React, { useState, useRef } from "react";
import ImportContactsModal from "../../import-contacts-modal";
import { Box, Stack, Typography, Button, Chip } from "@mui/material";
import ListIcon from '@mui/icons-material/List';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import AddSingleContact from "./AddSingleContact";
import ContactsTable from "./contacts-table";
import AgentsViewer from "./AgentsViewer";
import { useAgents } from "../api";
import DeleteListModal from "../../delete-list-modal";
import dayjs from "dayjs";

export default function ListViewer({ list }: { list: List | undefined }) {
    const [selectedAgent, setSelectedAgent] = useState<Agent | undefined>();
    const containerRef = useRef<HTMLDivElement>(null);
    const startDate = list?.start_utc && dayjs(list?.start_utc);
      const endDate = list?.end_utc ? dayjs(list?.end_utc) : dayjs();
      const daysOpen = endDate.diff(startDate, "day");
      const isArchived = !!list?.end_utc;
    
      const getChipColor = (days: number): "success" | "warning" | "error" => {
        if (days <= 7) return "success";
        if (days <= 14) return "warning";
        return "error";
      };

      const chipLabel = isArchived
        ? `Length: ${daysOpen} day${daysOpen !== 1 ? "s" : ""}`
        : `Open ${daysOpen} day${daysOpen !== 1 ? "s" : ""}`;

      const onSelectAgent = (agent: Agent) => {
        if (agent.id === selectedAgent?.id) return setSelectedAgent(undefined);
        setSelectedAgent(agent);
        containerRef.current?.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
      };
    
  
  return (
    <Box
      ref={containerRef}
      sx={{
        background: "#f5f5f5",
        height: "100%",
        padding: 3,
        paddingTop: 2,
        overflow: "auto",
        paddingBottom: 10,
      }}
    >
      <Stack gap={4}>
        <Stack flexDirection="row" justifyContent="space-between">
          <Stack>
            <Stack flexDirection="row" gap={4} alignItems="center">
              <Stack flexDirection="row" gap={1} alignItems="center">
                <ListIcon color="primary" style={{ fontSize: 28 }} />
                <Typography style={{ fontWeight: "bold", fontSize: 22 }}>
                  {list?.name}
                </Typography>
              </Stack>
              {startDate && (
                <Chip
                  size="small"
                  label={chipLabel}
                  color={isArchived ? "default" : getChipColor(daysOpen)}
                  sx={{
                    fontWeight: 600,
                    fontSize: 11,
                    width: 100,
                    height: 20,
                  }}
                />
              )}
            </Stack>
            <Typography
              style={{
                fontSize: 13,
                color: "gray",
                fontWeight: "bold",
                paddingLeft: 5,
              }}
            >
              {list?.end_utc
                ? `Archived on ${dayjs(list.end_utc).format("MM/DD/YYYY")}`
                : "Manage Contacts and Agents in this List"}
            </Typography>
          </Stack>
          <Stack flexDirection="row" gap={1} alignItems="center">
            {!list?.end_utc && <DeleteListModal list={list} />}
          </Stack>
        </Stack>
        {!list?.end_utc && <AddSingleContact />}
        <ContactsTable
          list={list}
          selectedAgent={selectedAgent}
          onClearAgent={() => setSelectedAgent(undefined)}
        />
        <AgentsViewer
          list={list}
          selectedAgent={selectedAgent}
          onSelectAgent={onSelectAgent}
        />
      </Stack>
    </Box>
  );
}

